module.exports = __webpack_public_path__ + "static/header-volunteer-c080c22687634400fe4c5a096f68c607.jpg";